import { Flex } from "@chakra-ui/react";
import { RelatorioInadimplentesItem } from "core/features/relatorios/typings/index";
import colors from "core/resources/theme/colors";
import TableHeaderRow from "./components/TableHeaderRow";
import TableItemRow from "./components/TableItemRow";
import TableTotalRow from "./components/TableTotalRow";

export interface TableItemInadimplenteProps {
  item: RelatorioInadimplentesItem;
}

function TableItemInadimplente({ item }: TableItemInadimplenteProps) {
  return (
    <Flex maxW="100%" flexDir="column">
      <Flex bg={colors.black100} gridGap={1} py={3} pr={6} fontWeight="medium">
        <TableHeaderRow />
      </Flex>
      <Flex w="100%" flexDir="column">
        {item.contas.map((conta, index) => (
          <Flex
            key={conta.id}
            bg={index % 2 === 0 ? "white" : colors.black100}
            gridGap={1}
            py={3}
            pr={6}
          >
            <TableItemRow conta={conta} />
          </Flex>
        ))}

        <Flex
          bg={item.contas.length % 2 === 0 ? "white" : colors.black100}
          gridGap={1}
          py={3}
          pr={6}
          fontWeight="bold"
        >
          <TableTotalRow item={item} />
        </Flex>
      </Flex>
    </Flex>
  );
}

export default TableItemInadimplente;
